module.exports = __webpack_public_path__ + "static/email-template-sso-3b4025d8b56da170009a5f483680a33b.jpg";